import styled from 'styled-components';
import { Link } from 'react-router-dom';
import theme from '../../theme';

const Nav = styled.nav`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: fixed;
    z-index: 10;
    width: calc(100% - 40px);
    max-width: 270px;
    height: 36px;
    border-radius: 90px;
    background-color: ${theme.white};
    padding: 7px 0;
    bottom: 10px;
`;

const NavItem = styled(Link)`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    padding: 10px 15px;
    cursor: pointer;
    transition: all 0.2s ease-out;
`;

const IconWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

const NotificationDot = styled.div`
  position: absolute;
  top: -2px;
  right: -2px;
  width: 12px;
  height: 12px;
  background-color: red;
  border-radius: 50%;
`;

export { Nav, NavItem, IconWrapper, NotificationDot };